const root = 'velo-payment-view';

const TestIds = {
  TAB_ROOT: `${root}-tab`,
  CLOSE_BUTTON: 'payment-view-close-button',
  TITLE: `${root}-title`,
};

export { root, TestIds };
